'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'User',
  basePath: ':basePath',
  endpoint: 'users',
  debug: false,
  methods: null,
  relations : {}
};

var UserResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

var getResourceOptions = function(options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'User',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {
      updatePassword: function(id, params, options) {
        // Filter so only password related items are sent
        options = options || {};
        options.endpoint = 'users/update_password';

        var filteredParams = {
          oldPassword: params.oldPassword,
          newPassword: params.newPassword,
          passwordConfirmation: params.passwordConfirmation
        };
        return this.update(id, filteredParams, options);
      },

      destroyMeta: function(id, params, options) {
        params = params || {};
        options = options || {};

        options.endpoint = 'users/destroy_meta';

        var filteredParams = {
          metaId: params.id
        };

        return this.update(id, filteredParams, options);
      }
    },

    modelMethods: {
    },

    // definition formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri
      }
    },

    syncTriggers: {}
  };
};

module.exports = UserResource;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/user/UserResource.js